<template>
  <section>
    <!-- SB-26 -->
    <div
      id="sb-26"
      v-if="$store.state.currentLocation >= 26"
    >
      <banner-full-width headerText="Interventions en cas d'urgence pour l'athlète"></banner-full-width>
      <content-block>
        <!-- 5-01-00 -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">À venir</h2>
        <p>Vous pouvez faire bien des choses pour vous protéger en aviron. Vous êtes aussi responsable de la sécurité des personnes qui devront peut-être vous secourir en cas d'urgence.</p>
        <p>Dans cette section, nous examinerons la façon de réagir correctement aux situations d'urgence sur l'eau.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="27"
          link="sb-27"
        >
          Je veux être prêt
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-27 -->
    <div
      id="sb-27"
      v-if="$store.state.currentLocation >= 27"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Savoir quoi faire en cas d'urgence </h2>
        <p>Une embarcation qui prend l'eau ou qui chavire peut rapidement se transformer en situation d'urgence nécessitant l'aide d'autrui.  </p>
        <p>Lorsque l'embarcation prend l'eau, vous pouvez écoper l'eau de la coque et continuer de ramer, mais cela n'est parfois pas suffisant. </p>
        <!-- <video
          src="@/assets/video/27-01a.mp4"
          controls
          class="img-fluid content-block__img"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          <track
            label="English"
            kind="subtitles"
            srclang="en"
            :src="`${publicPath}cc/27-01a.en.vtt`"
            default
          >
        </video>
        <accordion-icon
          headerText="Transcript"
          class="accordion-group accordion-group--red"
        >
          <p>When a boat has taken on some water, the result of a wake or rough water conditions, it may be possible to bail the water from the boat and continue rowing. The crew is stopped and prepared for the coach boat to approach them. The coach’s boat approaches slowly and under control. The coach places their boat between the oars and riggers, on the leeward side of the shell, where possible. The coach can handle a bailer to the crew or take an injured rower out of the shell. If the rowing shell’s damaged or if someone is injured and unable to be taken out of the shell, the coach has the option of throwing a towline to the crew, to pull the crew to the coach boat, or tow the shell to a safe haven.</p>
        </accordion-icon> -->
        <p>Si vous chavirez, restez avec votre embarcation et ne tentez pas de ramer jusqu'à la berge, à moins de pouvoir toucher le fond.</p>
        <p>Cette vidéo vous explique pourquoi.</p>
        <video
          src="@/assets/video/27-01b-fr.mp4"
          controls
          class="img-fluid content-block__img"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          <track
            label="Francais"
            kind="subtitles"
            srclang="fr"
            :src="`${publicPath}cc/27-01b-fr.vtt`"
            default
          >
        </video>
        <accordion-icon
          headerText="Transcription"
          class="accordion-group accordion-group--red"
        >
          <p>Ceci peut vous arriver. Il est donc important de savoir comment réagir si votre bateau chavire ou est inondé. Rappelez-vous que l'hypothermie peut se produire rapidement en eau froide. Vous pourriez donc perdre votre capacité de nager en quelques minutes et être incapable d'embarquer seul dans un bateau de secours. Il est essentiel de rester avec votre bateau. N’essayez pas de nager vers la rive. Le bateau est un moyen de flottaison qui vous permet de garder votre corps hors de l'eau pour diminuer le risque de noyade. </p>
        </accordion-icon>
        <button-sequenced
          class="btn-nav--red"
          :loc="28"
          link="sb-28"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          Ce sont de sages paroles
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-28 -->
    <div
      id="sb-28"
      v-if="$store.state.currentLocation >= 28"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Savoir s'aider soi-même  </h2>
        <p>Si vous ramez seul et que votre embarcation chavire, vous allez peut-être devoir vous aider vous-même.</p>
        <p>Suivez ces étapes pour rester hors de danger.</p>
        <h3 class="text-red mt-4">Enfilez votre VFI </h3>
        <div class="row">
          <div class="col-sm bg-red text-center p-4 m-3">
            D'abord, dégagez vos pieds de l'embarcation. 
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            Puis, enfilez votre VFI et attachez-le. 
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            Gonflez-le, si besoin.
          </div>
        </div>
        <h3 class="text-red mt-4">Retournez le skiff ou utilisez-le comme flotteur</h3>
        <p>Voici la meilleure façon de vous y prendre.</p>
        <video
          src="@/assets/video/28-01a-fr.mp4"
          controls
          class="img-fluid content-block__img"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          <track
            label="Francais"
            kind="subtitles"
            srclang="fr"
            :src="`${publicPath}cc/28-01a-fr.vtt`"
            default
          >
        </video>
        <accordion-icon
          headerText="Transcription"
          class="accordion-group accordion-group--red"
        >
          <p>Dans cet exemple, vous verrez comment un rameur peut redresser son skiff et y rembarquer. Il utilise son pied pour enfoncer le portant submergé. En même temps, il tire l’autre portant vers lui pour remettre le bateau à l’endroit.  </p>
          <p>Il remet ensuite les rames en place, agrippant les poignées des rames pour stabiliser le bateau. </p>
          <p>Tout en tenant les poignées, il fait un battement avec ses jambes pour se propulser hors de l’eau, par-dessus le plat-bord et reprend place sur son siège.  </p>
          <p>Pratiquez cette opération dans une piscine ou en eau peu profonde.</p>
        </accordion-icon>
        <p>Si vous n'arrivez pas à retourner votre skiff, utilisez-le comme flotteur. Cela peut vous aider à attirer l'attention d'une personne qui pourra vous aider.</p>
        <video
          src="@/assets/video/28-01b-fr.mp4"
          controls
          class="img-fluid content-block__img"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          <track
            label="Francais"
            kind="subtitles"
            srclang="fr"
            :src="`${publicPath}cc/28-01b-fr.vtt`"
            default
          >
        </video>
        <accordion-icon
          headerText="Transcription"
          class="accordion-group accordion-group--red"
        >
          <p>Si vous ne pouvez pas redresser le skiff, le mieux est d'utiliser le bateau comme dispositif de flottaison. Hissez-vous hors de l'eau et allongez-vous sur votre bateau, en sortant votre corps le plus possible de l'eau. </p>
          <p>Si vous êtes près de la rive, retirez les rames. Hissez-vous sur la coque, parallèlement à celle-ci et pagayez avec vos mains jusqu’à la rive, comme sur une planche de surf. </p>
          <p>Essayez d'attirer l'attention de l’entraîneur, d’un copain ou d'autres équipages près de vous avec le sifflet. </p>
          <p>S’il y a d'autres bateaux dans les environs qui peuvent vous aider, dirigez-vous vers eux.</p>
          <p>Allongez-vous sur la poupe de leur bateau. Ils vous mèneront en lieu sûr. </p>
        </accordion-icon>
        <button-sequenced
          class="btn-nav--red"
          :loc="29"
          link="sb-29"
        >
          Bon à savoir
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-29 -->
    <div
      id="sb-29"
      v-if="$store.state.currentLocation >= 29"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Se préparer à obtenir de l'aide</h2>
        <p>Il est possible que votre équipage ait besoin d'aide ou que vous deviez aider un autre équipage. </p>
        <p>En règle générale, <strong class="text-red">l'équipage doit suivre les consignes du barreur ou du responsable de l'équipage jusqu'à l'arrivée du bateau de sauvetage</strong>.</p>
        <p>Voici ce que vous devez savoir si vous vous retrouvez en situation de sauvetage.</p>
        <div class="accordion-group">
          <accordion
            header-text="S'approcher d'une embarcation"
            class="accordion--red"
          >
          <p>Cette vidéo vous explique comment l'aide peut être fournie.</p>
          <video
          src="@/assets/video/27-01a-fr.mp4"
          controls
          class="img-fluid content-block__img"
          poster="@/assets/img/_poster/poster.png"
          controlslist="nodownload"
        >
          <track
            label="Francais"
            kind="subtitles"
            srclang="fr"
            :src="`${publicPath}cc/27-01a-fr.vtt`"
            default
          >
        </video>
        <div class="accordion-group>">
       <accordion
          headerText="Transcription"
          class="accordion--light-grey"
        >
      <p>Lorsque le bateau est inondé, suite à des remous ou au passage d'un gros bateau, il suffit peut-être d'écoper l'eau et de continuer à ramer. L'équipage s'arrête et se prépare à l'arrivée du bateau de l'entraîneur.  </p>
      <p>Le bateau approche lentement et de façon contrôlée en se positionnant entre les rames et les portants, sous le vent du bateau, là où il peut.  </p>
      <p>L'entraîneur peut tendre une écope à l'équipage ou transborder un rameur blessé du bateau.</p>
      <p>Si le bateau est endommagé ou qu'un blessé ne peut pas être transbordé du bateau, l'entraîneur peut lancer une ligne de remorque pour tirer le bateau vers le sien ou remorquer l'équipage vers un endroit sécuritaire.</p>
      </accordion>
        </div>
          </accordion>
          <accordion
            header-text="Attendre les secours dans une embarcation inondée"
            class="accordion--red"
          >
            <ul>
              <li>Les membres de l'équipage doivent sortir de l'embarcation inondée puisque le poids additionnel de l'eau peut causer la rupture de la coque.</li>
              <li>Les rameurs doivent sortir calmement et avec maîtrise.</li>
              <li>Il est préférable de se succéder pour sortir (un à la fois ou deux à la fois pour permettre une meilleure maîtrise).</li>
            </ul>
          </accordion>
          <accordion
            header-text="Attendre les secours après avoir chaviré"
            class="accordion--red"
          >
            <ul>
              <li>D'abord, chacun doit retirer son VFI de l'embarcation pour l'enfiler.</li>
              <li>Ne comptez pas sur les rames qui ne sont pas en bois pour flotter, puisqu'elles peuvent se remplir d'eau et s'enfoncer dans l'eau.</li>
              <li>S'il s'agit d'un quatre ou d'un huit, l'équipage doit monter sur la coque par groupe de deux ou de trois; les paires doivent être reliées sur la coque. </li>
              <li>Liez vos mains ensemble et essayez de sortir le plus possible de l'eau.</li>
              <li>Gardez vos vêtements puisqu'ils offrent une couche isolante.  </li>
              <li>Utilisez votre sifflet pour attirer l'attention vers l'endroit où vous vous trouvez. </li>
              <li>Si la coque casse ou qu'elle ne flotte plus suffisamment, adoptez la position fœtale individuellement ou caucus en groupe pour diminuer la perte de chaleur.</li>
            </ul>
          </accordion>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="30"
          link="sb-30"
        >
          Je comprends
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-30 -->
    <div
      id="sb-30"
      class="bg-img bg-img--04"
      v-if="$store.state.currentLocation >= 30"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Porter secours à des rameurs </h2>
        <p>Lors d'une opération de sauvetage, rappelez-vous{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Si le sauveteur est dans une embarcation à coque rigide, il doit offrir un contrepoids aux rameurs alors qu'ils grimpent dans l'embarcation (les échelles d’embarcation offrent un meilleur accès pour ceux qui ont besoin de recevoir de l'aide pour monter).  </li>
          <li>Ceux qui sont déjà montés dans le bateau doivent continuer de l'équilibrer et d'aider les autres pour éviter de faire chavirer l'embarcation de sauvetage.  </li>
          <li>Si le sauveteur est dans une embarcation à paroi souple, le sauveteur et les rameurs repêchés doivent aider les autres en les tirant sur le bord du bateau de sauvetage. </li>
          <li>Dès que tous les rameurs sont hors de danger hors de l'eau, ils doivent être enroulés dans une couverture thermique. S'il s'agit d'un équipage, les membres devraient se blottir les uns contre les autres pour combiner la chaleur de leur corps.</li>
          <li>Si l'équipage n'a pas de VFI et que son embarcation a chaviré ou qu'elle prend l'eau, le sauveteur doit <strong>d'abord remettre un VFI</strong> à chaque membre de l'équipage dès que possible et ensuite, les aider à sortir de l'eau et à monter dans l'embarcation de sécurité. </li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="31"
          link="sb-31"
        >
          C'est logique
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-31 -->
    <div
      id="sb-31"
      v-if="$store.state.currentLocation >= 31"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Se protéger contre l'hypothermie </h2>
        <p>L'hypothermie fait partie des risques lorsqu'on se retrouve à l'eau, particulièrement par temps froid avec du vent et de la pluie. Cela se produit lorsque la température du corps baisse à moins de 35 °C.</p>
        <div class="row">
          <div class="col-sm bg-light-red-200 text-center p-4 m-3">
            <img
              src="@/assets/img/_content/31-warning--dark.svg"
              class="img-fluid w-50 mb-4"
              alt="1"
              srcset=""
            >
            <p>Lorsqu'une personne souffre d'<strong>hypothermie légère</strong>, elle grelotte. Même si elle a perdu sa motricité fine, elle peut tout de même marcher et parler. </p>
          </div>
          <div class="col-sm bg-light-red-100 text-center p-4 m-3">
            <img
              src="@/assets/img/_content/31-warning--dark.svg"
              class="img-fluid w-50 mb-4"
              alt="2"
              srcset=""
            >
            <p>Lorsqu'une personne souffre d'<strong>hypothermie modérée</strong>, elle est confuse et semi-consciente. Elle a une faible coordination motrice, particulièrement avec les mains. Par exemple, elle n'arrivera peut-être pas à remonter la fermeture éclair de son coupe-vent ou à fermer une dame de nage. Elle peut avoir du mal à parler clairement et elle peut grelotter de manière incontrôlable.  </p>
          </div>
          <div class="col-sm bg-red text-center p-4 m-3">
            <img
              src="@/assets/img/_content/31-warning.svg"
              class="img-fluid w-50 mb-4"
              alt="3"
              srcset=""
            >
            <p>Lorsqu'une personne souffre d'<strong>hypothermie grave</strong>, elle grelotte par vagues violentes, puis s'arrête. L'hypothermie grave met la vie en danger. <strong>Composez immédiatement le 911</strong>.</p>
          </div>
        </div>
        <p>Lorsque la personne qui souffre d'hypothermie est hors de danger dans l'embarcation de sécurité, couvrez-la d'une couverture thermique pour diminuer la perte de chaleur et pour la protéger contre le vent et la pluie. Empêchez la perte de chaleur supplémentaire en retirant les vêtements mouillés, en protégeant la personne avec des vêtements secs ou des couvertures ou avec d'autres personnes qui feront du corps à corps avec la personne.</p>
        <p>Alors que l'hypothermie modérée peut être inversée, l'hypothermie grave peut entraîner la mort.</p>
        <p>Prenez des précautions en limitant votre temps de sortie par temps froid et en étant vêtu convenablement, avec un chapeau notamment. Il est plus facile d'enlever une couche au besoin.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="32"
          link="sb-32"
        >
          J'y veillerai
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-32 -->
    <div
      id="sb-32"
      v-if="$store.state.currentLocation >= 32"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Se protéger contre l'hyperthermie </h2>
        <p>L'hyperthermie correspond à l'élévation de la température du corps, généralement en raison de températures extérieures élevées. Des exercices prolongés et vigoureux par temps chaud et humide en sont la cause principale. Comme avec l'hypothermie, il peut y avoir différents symptômes associés à l'hyperthermie selon la gravité.</p>
        <slick
          ref="slick01"
          :options="slickOptions01"
          class="carousel"
        >
          <!-- Slide 01 -->
          <div class="mt-5">
            <div class="carousel__text pl-5">
              <img
                src="@/assets/img/_content/32-heat-cramping-fr.svg"
                class="d-block mx-auto w-50 mb-4"
                alt="Crampes liées à la chaleur"
              />
              <div class="row">
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Symptômes</h3>
                  <ul class="chevron-list">
                    <li>Spasmes musculaires involontaires </li>
                    <li>Transpiration importante des grands muscles qui travaillent </li>
                  </ul>
                </div>
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Traitement</h3>
                  <p>Massage pour un soulagement immédiat</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Slide 02 -->
          <div>
            <div class="carousel__text pl-5">
              <img
                src="@/assets/img/_content/32-heat-exhaustion-fr.svg"
                class="d-block mx-auto w-50 mb-4"
                alt="Épuisement par la chaleur"
              />
              <div class="row">
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Symptômes</h3>
                  <ul class="chevron-list">
                    <li>Crampes</li>
                    <li>Fatigue</li>
                    <li>Performance diminuée</li>
                    <li>Jugement affaibli et changements émotionnels </li>
                    <li>Confusion, vomissements et convulsions possibles</li>
                  </ul>
                </div>
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Traitement</h3>
                  <p>Repos et apport en liquide </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Slide 03 -->
          <div>
            <div class="carousel__text pl-5">
              <img
                src="@/assets/img/_content/32-heatstroke-fr.svg"
                class="d-block mx-auto w-50 mb-4"
                alt="Heatstroke"
              />
              <div class="row">
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Symptômes</h3>
                  <ul class="chevron-list">
                    <li>Peau sèche et/ou moite  </li>
                    <li>Perte de conscience, dans les cas extrêmes</li>
                  </ul>
                </div>
                <div class="col-sm">
                  <h3 class="text-center mb-4" style="font-weight: 700">Traitement</h3>
                  <p>Composez le 911 pour obtenir de l'aide médicale immédiate.  </p>
                  <p>Abaissez le corps dans de l'eau fraîche et le maintenir en position horizontale.</p>
                  <p>Pratiquez la RCR si la personne ne respire pas ou qu'elle n’a pas de pouls. Cessez le traitement lorsqu'elle reprend connaissance et qu'elle redevient alerte. </p>
                  <p>Ne donnez pas d'alcool ou de caféine à la personne.</p>
                </div>
              </div>
            </div>
          </div>
        </slick>
        <p>Suivez ces pratiques simples pour prévenir l'hyperthermie.</p>
        <ul class="chevron-list">
          <li>Restez bien hydraté avant de sortir ramer, pendant et après.  </li>
          <li>Évitez de boire des boissons qui ont plus de 2,5 % de sucre ou qui contiennent de l'alcool ou de la caféine.</li>
          <li>Évitez les capsules de sel ou les boissons pour sportifs à concentration élevée en sodium. </li>
          <li>Si la température et l'humidité sont extrêmement élevées, ramez tôt le matin ou tard en soirée. </li>
          <li>Lorsque vous n'êtes pas sur l'eau, restez à l'ombre. </li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="33"
          link="sb-33"
        >
          Sages conseils
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-33 -->
    <div
      id="sb-33"
      class="bg-img bg-img--02"
      v-if="$store.state.currentLocation >= 33"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Reconnaître et traiter les commotions cérébrales </h2>
        <p>Une commotion cérébrale est une grave blessure à la tête qui peut avoir des conséquences sur la fonction cérébrale. C'est une blessure particulièrement difficile à traiter, car sa gravité n'est pas toujours évidente (souvent pas au début). Il est essentiel d'y porter une attention immédiate.</p>
        <p>Dès qu’une personne se blesse à la tête, au cou ou dans le haut du corps et qu'elle présente des signes ou des symptômes de commotion cérébrale, elle doit cesser ses activités physiques. </p>
        <p>L'Outil de reconnaissance des commotions cérébrales est un guide qui explique ce qu'il faut surveiller et comment réagir. Les entraîneurs devraient toujours avoir un exemplaire du guide à portée de main et il devrait être affiché dans le hangar afin d'être consulté facilement.  </p>
        <p>Si vous devez cesser vos activités en raison d'une commotion cérébrale potentielle, soyez franc et honnête à propos de vos symptômes. Suivez les conseils médicaux pour reprendre vos activités d'aviron de manière sécuritaire.</p>
        <p>La politique sur les commotions cérébrales de RCA, les documents pédagogiques et les lignes directrices pour un retour à l'aviron se trouvent avec l'Outil de reconnaissance des commotions cérébrales sur le site web de RCA.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="34"
          link="sb-34"
        >
          Je réviserai les signes et symptômes de commotion cérébrale
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-34 -->
    <div
      id="sb-34"
      v-if="$store.state.currentLocation >= 34"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Suivre les protocoles de communication en cas d'urgence  </h2>
        <p>RCA recommande d'afficher clairement la liste des numéros de téléphone d'urgence dans chaque club.  </p>
        <p>La liste doit comprendre{{'\xa0'}}:  </p>
        <ul class="chevron-list">
          <li>L'adresse physique du club, avec les indications pour y accéder</li>
          <li>Le numéro d'un médecin, des services ambulanciers et de la police </li>
          <li>Le service des incendies </li>
          <li>L'urgence de l'hôpital du secteur  </li>
          <li>Le numéro de la police portuaire ou fluviale </li>
          <li>Les services d'urgence qui peuvent répondre le plus rapidement aux urgences sur l'eau</li>
          <li>Un exemple de dialogue pour le service appelé, afin d'éviter toute confusion sous l'effet du stress</li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="35"
          link="sb-35"
        >
          C’est logique
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-35 -->
    <div
      id="sb-35"
      class="quiz-bg"
      v-if="$store.state.currentLocation >= 35"
    >
      <content-block>
        <h2 class="content-block__header ">En eaux profondes</h2>
        <quiz-radio
          :questions="q01"
          @quiz-complete="
                $store.dispatch('showNext', { n: 36, el: '#menu' })
              "
        ></quiz-radio>
      </content-block>
    </div>

    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 36"
    >
      <h3>Menu principal</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';
// import Slick from 'vue-slick';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

// carousel

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
    // Slick
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p class="text-key-take">Votre skiff vient de chavirer et vous n'arrivez pas à remonter dans votre embarcation. </p>
            <p class="text-key-take">Quelle est la solution la plus sûre?</p>
          `,
          questionArray: [
            'Composez le 911 avec votre téléphone cellulaire',
            'Nagez jusqu\'à la berge',
            'Nagez jusqu\'au bateau le plus près',
            'Enfilez votre VFI, utilisez votre skiff comme flotteur et utilisez votre sifflet pour appeler à l\'aide'
          ],
          corrective: 'Enfilez votre VFI, utilisez votre skiff comme flotteur et utilisez votre sifflet pour appeler à l\'aide',
          model: [],
          answer: '',
          answerText: `
            <p>Avant d'utiliser votre téléphone ou de vous mettre à nager, vous devez veiller à votre sécurité immédiate en enfilant votre VFI et en utilisant votre embarcation comme dispositif de flottaison. Utilisez ensuite votre sifflet pour attirer l'attention de quelqu'un. Ne quittez pas votre embarcation sauf au moment de monter dans le bateau de sauvetage.</p>
          `
        }
      ],
      // carousel options

      slickFor01: {
        // options can be used from the plugin documentation
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false
        // asNavFor: '.carousel--01'
      },
      slickOptions01: {
        // options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: false,
        accessibility: true,
        // adaptiveHeight: true,
        // arrows: false,
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        draggable: true,
        edgeFriction: 0.3,
        centerMode: false,
        swipe: true
      }
    }
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/5-athlete-emergency-response-mbl-fr.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    background-image: url("../assets/img/_chapter-headers/dsk/5-athlete-emergency-response-dsk-fr.jpg");
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
